import React from "react";
import { TextField, TextFieldProps } from "@mui/material";
import { useField } from "formik";

type OcTextFieldFormikProps = TextFieldProps & { name: string };

export const OcTextFieldFormik: React.FC<OcTextFieldFormikProps> = (props) => {
  const [field, meta, helper] = useField(props.name);

  return (
    <TextField
      onChange={(e) => helper.setValue(e.target.value)}
      onFocus={() => helper.setError(undefined)}
      variant="outlined"
      {...props}
      error={props.error || Boolean(meta.error)}
      helperText={meta.error || props.helperText}
      value={field.value}
    />
  );
};
